import { z } from 'zod';

export const baseMessageSchema = z.object({
  timestamp: z.number(),
  id: z.string().uuid(),
  // Optional Sentry trace context for distributed tracing
  // These fields allow trace propagation across websocket boundaries
  _sentryTrace: z.string().optional(),
  _sentryBaggage: z.string().optional(),
  // Optional hierarchical correlation IDs for cross-surface log linking.
  // Senders stamp these (when known) so realtime-api can tag the same
  // session across client, host, and API. Additive + optional = safe.
  _machineId: z.string().optional(),
  _broadcastId: z.string().optional(),
});

export type BaseMessage = z.infer<typeof baseMessageSchema>;

export const createMessageId = () => {
  // If crpyto is available, use it to create a message id
  if (typeof crypto !== 'undefined') {
    return crypto.randomUUID();
  }
  // Otherwise, generate a UUID v4 format manually
  // UUID v4 format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
  const hex = () => Math.floor(Math.random() * 16).toString(16);
  const uuid = [
    // 8 hex digits
    Array.from({ length: 8 }, hex).join(''),
    // 4 hex digits
    Array.from({ length: 4 }, hex).join(''),
    // 4 hex digits with version 4
    '4' + Array.from({ length: 3 }, hex).join(''),
    // 4 hex digits with variant bits (8, 9, a, or b)
    ['8', '9', 'a', 'b'][Math.floor(Math.random() * 4)] + Array.from({ length: 3 }, hex).join(''),
    // 12 hex digits
    Array.from({ length: 12 }, hex).join(''),
  ].join('-');

  return uuid;
};
